import { Empty } from 'antd';

export const customizeRenderEmpty = (
  description = 'Currently no products.'
) => <Empty description={description} image={Empty.PRESENTED_IMAGE_SIMPLE} />;
